<template>
  <div id="home" v-if="this.$root.isAuthenticated">
    <div @mousemove="resetTimer" @keydown="resetTimer" @click="resetTimer">
    <!-- begin:: Page -->
    <!-- begin:: Header Mobile -->
    <div id="kt_header_mobile" class="kt-header-mobile kt-header-mobile--fixed">
      <div class="kt-header-mobile__logo">
        <router-link to="/">{{ this.$root.siteConfig.SiteName }}</router-link>
      </div>

      <div class="kt-header-mobile__toolbar">
        <button class="kt-header-mobile__toggler kt-header-mobile__toggler--left" id="kt_aside_mobile_toggler">
          <span></span>
        </button>

        <button class="kt-header-mobile__toggler" id="kt_header_mobile_toggler">
          <span></span>
        </button>

        <button class="kt-header-mobile__topbar-toggler" id="kt_header_mobile_topbar_toggler">
          <i class="flaticon-more"></i>
        </button>
      </div>
    </div>

    <!-- end:: Header Mobile -->
    <div class="kt-grid kt-grid--hor kt-grid--root">
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
        <!-- begin:: Aside -->
        <button class="kt-aside-close" id="kt_aside_close_btn">
          <i class="la la-close"></i>
        </button>

        <div class="kt-aside kt-aside--fixed kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop" id="kt_aside">
          <!-- begin:: Aside -->
          <div class="kt-aside__brand kt-grid__item" id="kt_aside_brand">
            <div class="kt-aside__brand-logo">
              <router-link to="/">
                {{ this.$root.siteConfig.SiteName }}
              </router-link>
            </div>

            <div class="kt-aside__brand-tools">
              <button class="kt-aside__brand-aside-toggler" id="kt_aside_toggler">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                    height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                        id="Path-94" fill="#000000" fill-rule="nonzero"
                        transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) " />
                      <path
                        d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                        id="Path-94" fill="#000000" fill-rule="nonzero" opacity="0.3"
                        transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) " />
                    </g>
                  </svg>
                </span>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                    height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                        id="Path-94" fill="#000000" fill-rule="nonzero" />
                      <path
                        d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                        id="Path-94" fill="#000000" fill-rule="nonzero" opacity="0.3"
                        transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) " />
                    </g>
                  </svg>
                </span>
              </button>
              <!-- <button class="kt-aside__brand-aside-toggler kt-aside__brand-aside-toggler--left" id="kt_aside_toggler"><span></span></button> -->
            </div>
          </div>

          <!-- end:: Aside -->
          <!-- begin:: Aside Menu -->
          <div class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper">
            <div id="kt_aside_menu" class="kt-aside-menu" data-ktmenu-vertical="1" data-ktmenu-scroll="1"
              data-ktmenu-dropdown-timeout="500">
              <ul class="kt-menu__nav">
                <!-- Dashboard menu for AGENT_REPORT → submenu (ซ่อนสำหรับ COMPANY_PROFILE_TYPE_BR ยกเว้น BR_DASHBOARD_AUDIT_STOCK) -->
                <li class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{ 'kt-menu__item--open': subIsActive('/AgentScoreDashboard') || subIsActive('/Dashboard') || subIsActive('/AgentStockOverdue') || $route.path === '/' }"
                  v-if="(this.$root.canShow(['AGENT_REPORT', 'BR_REPORT']) && !this.$root.hasBrProfile()) || this.$root.canShow(['BR_DASHBOARD_AUDIT_STOCK'])">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <i class="la la-trophy" style="font-size:1.4rem;"></i>
                    </span>
                    <span class="kt-menu__link-text">แดชบอร์ด</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">

                      
                      
                      <router-link to="/" tag="li" class="kt-menu__item" exact aria-haspopup="true"
                        v-if="this.$root.user.profile.role != 'QI_QIMAINTAIN'
                           && this.$root.user.profile.role != 'OFFICER_QIMAINTAIN'
                           && this.$root.user.profile.role != 'OFFICER_PLANT_QIMAINTAIN'
                           && this.$root.user.profile.role != 'LEAD_QIMAINTAIN'
                           && !this.$root.hasBudgetPlanProfile()">
                        <a class="kt-menu__link"  v-if="this.$root.canShow(['super_admin'])">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot"><span></span></i>
                          <span class="kt-menu__link-text">รายงาน Stock รายบาร์โค้ด</span>
                        </a>
                      </router-link>

                     <router-link to="/AgentScoreDashboard" v-if="this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN'])" tag="li" class="kt-menu__item" aria-haspopup="true">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot"><span></span></i>
                          <span class="kt-menu__link-text">คะแนนตัวแทนจำหน่าย</span>
                        </a>
                      </router-link>

                      <router-link  to="/AgentStockOverdue" v-if="this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN', 'BR_DASHBOARD_AUDIT_STOCK'])" tag="li" class="kt-menu__item" aria-haspopup="true">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot"><span></span></i>
                          <span class="kt-menu__link-text">รายงาน STOCK ระบบเบียร์สด</span>
                        </a>
                      </router-link>
                      <!-- <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">แดชบอร์ด</span>
                        </span>
                      </li> -->
                    

                      
                    </ul>
                  </div>
                </li>

                <!--
                  CR-QC-Hide-Menu-From-Role-User (2026-10-02)
                  เอา 'USER_QI' ออกด้วยเหตุเดียวกับ submenu ด้านล่าง
                  หมวด "จัดการข้อมูล" มี submenu เดียวคือ "ข้อมูลพื้นฐาน"
                  ถ้าคงไว้ หัวหมวดจะค้างอยู่โดยไม่มีเมนูอยู่ใต้มันเลย
                -->
                <li class="kt-menu__section"
                  v-if="this.$root.canShow([
                    'MASTER_USER',
                    'MANAGE_MASTER',
                    'MANAGE_COMPANY_PROFILE',
                    'MANAGE_SUB_AGENT_USER',
                    'MANAGE_PLANT',
                    'MASTER_AGENT',
                    'MANAGE_SHOP',
                    'MANAGE_SHOPPROFILE',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT',
                    'ADMIN_QI',
                    'MANAGER_QI',
                    'MANAGE_SHOP_SUB_AGENT',
                    'MANAGE_SUPPLIER',
                    'MANAGE_TRANSPORT',
                    'MANAGE_CONTACT',
                    'MANAGE_PRODUCT',
                    'MASTER_HOLDING',
                    'MANAGE_BRAND',
                    'MANAGE_BARCODE',
                    'MANAGE_BARCODE_AGENT',
                    'MANAGE_BARCODE_SUB_AGENT',
                    'MANAGE_ORDER',
                    'MANAGE_APPROVER',
                    'MANAGE_SETTING',
                    'MANAGE_PRODUCTBRAND',
                    'MANAGE_SALESAREA'
                  ])"
                >
                  <h4 class="kt-menu__section-text">จัดการข้อมูล</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>

                <!--
                  CR-QC-Hide-Menu-From-Role-User (2026-10-02)
                  เอา 'USER_QI' ออกจาก canShow ของเมนู "ข้อมูลพื้นฐาน" ด้วย
                  เพราะหลังส่ง 'USER_QI' ออกจาก /Master/ManageShopChangeRequest แล้ว
                  ไม่เหลือเมนูลูกใดที่ USER_QI มองเห็นอีก → ถ้าคงไว้ เมนูนี้จะเปิดออกมาว่างเปล่า
                -->
                <li class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{ 'kt-menu__item--open': subIsActive('/Master') }"
                  v-if="this.$root.canShow([
                    'MASTER_USER',
                    'MANAGE_MASTER',
                    'MANAGE_COMPANY_PROFILE',
                    'MANAGE_SUB_AGENT_USER',
                    'MANAGE_PLANT',
                    'MASTER_AGENT',
                    'MANAGE_SHOP',
                    'MANAGE_SHOPPROFILE',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT',
                    'ADMIN_QI',
                    'MANAGER_QI',
                    'MANAGE_SHOP_SUB_AGENT',
                    'MANAGE_SUPPLIER',
                    'MANAGE_TRANSPORT',
                    'MANAGE_CONTACT',
                    'MANAGE_PRODUCT',
                    'MASTER_HOLDING',
                    'MANAGE_BRAND',
                    'MANAGE_BARCODE',
                    'MANAGE_BARCODE_AGENT',
                    'MANAGE_BARCODE_SUB_AGENT',
                    'MANAGE_ORDER',
                    'MANAGE_APPROVER',
                    'MANAGE_SETTING',
                    'MANAGE_PRODUCTBRAND',
                    'MANAGE_SALESAREA'
                  ])"
                >
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">ข้อมูลพื้นฐาน</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">ข้อมูลพื้นฐาน</span>
                        </span>
                      </li>
                      <router-link to="/Master/Users" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['MASTER_USER'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการสมาชิก</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/CompanyProfile" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_COMPANY_PROFILE',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการโปรไฟล์บริษัท</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/AgentUsers" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShowExSuperAdmin([
                          'MANAGE_SUB_AGENT_USER',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลสมาชิกตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</span>
                        </a>
                      </router-link>

                      <!-- <router-link
                        to="/Master/Roles"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="this.$root.canShow(['MANAGE_MASTER','MASTER_ROLE'])"
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการบทบาท</span>
                        </a>
                      </router-link>-->

                      <router-link to="/Master/Plant" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_PLANT'])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลคลังสินค้า</span>
                        </a>
                      </router-link>
                      <router-link to="/Master/Agents" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow(['MANAGE_MASTER', 'MASTER_AGENT'])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลตัวแทนจำหน่าย</span>
                        </a>
                      </router-link>
                      <router-link to="/Master/ManageShop" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_SHOP'])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลร้านค้า</span>
                        </a>
                      </router-link>

                      <!--
                        CR-QC-Hide-Menu-From-Role-User (2026-10-02)
                        เอา 'USER_QI' ออกจาก canShow เพื่อซ่อนเมนูนี้จากบทบาท "พนักงาน"
                        ของโปรไฟล์ประเภท "งานตรวจสอบคุณภาพเบียร์สด" (COMPANY_PROFILE_TYPE_QI)
                        มติเจ้าของงาน: ซ่อนเฉพาะเมนู — route guard (router.js) และ API
                        (ShopChangeRequestController / MasterShopChangeRequestController)
                        ยังเปิดให้ USER_QI ตามเดิมโดยตั้งใจ
                      -->
                      <router-link to="/Master/ManageShopChangeRequest" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'MANAGE_MASTER',
                            'MANAGE_SHOPPROFILE',
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT',
                            'ADMIN_QI',
                            'MANAGER_QI',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการขอแก้ไขข้อมูลร้านค้า</span>
                        </a>
                      </router-link>

                      <!-- <router-link
                        to="/Master/ManageShopProfile"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'MANAGE_MASTER',
                            'MANAGE_SHOPPROFILE',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i
                            class="kt-menu__link-bullet kt-menu__link-bullet--dot"
                          >
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text"
                            >จัดการข้อมูลโปรไฟล์ร้านค้า</span
                          >
                        </a>
                      </router-link> -->

                      <router-link to="/Master/ManageShopSubAgent" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'MANAGE_MASTER',
                            'MANAGE_SHOP_SUB_AGENT',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/Supplier" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SUPPLIER',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล Supplier</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/ManageTransport" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'MANAGE_MASTER',
                            'MANAGE_TRANSPORT',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลขนส่ง</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/Contact" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_CONTACT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลผู้ติดต่อ</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/AlertPMConfig" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลวัน Alert PM</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/Product" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_PRODUCT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลสินค้า</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/Holding" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MASTER_HOLDING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ระยะเวลาถือครองสินค้า</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/ManageBrand" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_BRAND'])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการงบประมาณ</span>
                        </a>
                      </router-link>

                      <!-- <router-link
                        to="/Master/ManageCheckHoldProduct"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow(['MANAGE_MASTER', 'MANAGE_HOLD'])
                        "
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ใบตรวจสอบอุปกรณ์(Hold)</span>
                        </a>
                      </router-link>-->
                      <router-link to="/Master/ManageBarcode" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow(['MANAGE_MASTER'])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล Barcode</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/ManageBarcode" tag="li" class="kt-menu__item" aria-haspopup="true" 
                        v-if="!this.$root.canShow(['super_admin']) && this.$root.canShow(['MANAGE_BARCODE_AGENT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล Barcode (ตัวแทน)</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/ManageBarcode" tag="li" class="kt-menu__item" aria-haspopup="true" 
                        v-else-if="!this.$root.canShow(['super_admin']) && this.$root.canShow(['MANAGE_BARCODE_SUB_AGENT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล Barcode (ตัวแทนจำหน่ายย่อย)</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/Order" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER'])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลการสั่งซื้อ</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/Approver" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_APPROVER',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการผู้อนุมัติเบิก/ยืมทรัพย์สิน</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/Setting" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ตั้งค่าพื้นฐาน</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/ProductBrand" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_PRODUCTBRAND',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลแบรนด์</span>
                        </a>
                      </router-link>

                      <router-link to="/Master/SalesArea" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SALESAREA',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลเขตการขาย</span>
                        </a>
                      </router-link>

                       <!-------// ตั้งค่า Alert ถัง-->
                         <router-link to="/Master/OverdueSetting" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา</span>
                        </a>
                      </router-link>  
                       <!-------// ตั้งค่า Alert ถัง-->
                        <!-------// ตั้งค่า Alert ถัง-->
                        <router-link to="/Master/MasterProductUnitPrice" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ตั้งค่าราคาค่าถัง</span>
                        </a>
                      </router-link>  
                       <!-------// ตั้งค่า Alert ถัง-->


                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section"
                  v-if="this.$root.canShow([
                    'JOB_ADMIN_IMPORT_NEW_ASSETS',
                    'JOB_ADMIN_PRODUCE',
                    'JOB_ADMIN_DESTROY',
                    'JOB_ADMIN_TRANSFER_TO_AGENT',
                    'JOB_ADMIN_REPAIR_SUPPLIER',
                    'JOB_ADMIN_RETURN_SUPPLIER',
                    'JOB_ADMIN_TRANSFER_TO_SHOP',
                    'JOB_ADMIN_PICKUP',
                    'JOB_ADMIN_RETURN',
                    'COMPANY_PROFILE_TYPE_AGENT',
                    'JOB_ADMIN_EXCHANGE',
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB',
                    'JOB_ADMIN_WRITE_OFF_STOCK_PLANT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_AGENT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT',
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'LEAD_QIMAINTAIN'
                  ]) || this.$root.hasFormSummaryStockProfile()"
                >
                  <!-- FS-020 — เมนู "พิมพ์เอกสารสรุปข้อมูล" ในหมวดนี้ใช้ hasFormSummaryStockProfile()
                       แต่หัวข้อหมวดดูจาก canShow() ซึ่งอ่าน identity role เท่านั้น ไม่ดู company-profile claim
                       user ของ CR นี้ (identityRoles = none มีแต่โปรไฟล์) จึงเห็นเมนูแต่หัวข้อหมวดหาย
                       → ต่อเงื่อนไขให้ตรงกับเมนู (ใส่ FORM_SUMMARY_STOCK_* ใน canShow ไม่ได้ผล) -->
                  <h4 class="kt-menu__section-text">ใบงาน (Job)</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>

                <router-link to="/Jobs" tag="li" class="kt-menu__item" exact aria-haspopup="true" :class="{
                  'kt-menu__item--active': subIsActive('/Jobs/Edit'),
                  }"
                  v-if="this.$root.canShow([
                    'JOB_ADMIN_IMPORT_NEW_ASSETS',
                    'JOB_ADMIN_PRODUCE',
                    'JOB_ADMIN_DESTROY',
                    'JOB_ADMIN_TRANSFER_TO_AGENT',
                    'JOB_ADMIN_REPAIR_SUPPLIER',
                    'JOB_ADMIN_RETURN_SUPPLIER',
                    'JOB_ADMIN_TRANSFER_TO_SHOP',
                    'JOB_ADMIN_PICKUP',
                    'JOB_ADMIN_RETURN',
                    'COMPANY_PROFILE_TYPE_AGENT',
                    'JOB_ADMIN_EXCHANGE',
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB',
                    'JOB_ADMIN_WRITE_OFF_STOCK_PLANT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_AGENT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT',
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'LEAD_QIMAINTAIN'
                  ])"
                >
                  <a class="kt-menu__link">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                            id="Path-2" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                          <path
                            d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                            id="Path" fill="#000000" fill-rule="nonzero" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">ค้นหาใบงาน</span>
                  </a>
                </router-link>

                <li class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Jobs/Create'),
                  }"
                  v-if="this.$root.canShow([
                    'JOB_ADMIN_IMPORT_NEW_ASSETS',
                    'JOB_ADMIN_PRODUCE',
                    'JOB_ADMIN_DESTROY',
                    'JOB_ADMIN_TRANSFER_TO_AGENT',
                    'JOB_ADMIN_REPAIR_SUPPLIER',
                    'JOB_ADMIN_RETURN_SUPPLIER',
                    'JOB_ADMIN_TRANSFER_TO_SHOP',
                    'JOB_ADMIN_PICKUP',
                    'JOB_ADMIN_RETURN',
                    'COMPANY_PROFILE_TYPE_AGENT',
                    'JOB_ADMIN_EXCHANGE',
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB',
                    'JOB_ADMIN_WRITE_OFF_STOCK_PLANT',
                  ])"
                >
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">เปิดใบงานใหม่</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">เปิดใบงานใหม่</span>
                        </span>
                      </li>
                      <router-link to="/Jobs/Create/RETRIEVE_NEW_ITEM" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow(['JOB_ADMIN_IMPORT_NEW_ASSETS'])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รับทรัพย์สินใหม่</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/PRODUCE" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_PRODUCE'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ผลิตเบียร์สด</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/DESTROY" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_DESTROY'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ทำลายทรัพย์สิน</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/TRANSFER_TO_AGENT" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow(['JOB_ADMIN_TRANSFER_TO_AGENT'])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ส่งสินค้าไปยังตัวแทน</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/REPAIR_SUPPLIER" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_REPAIR_SUPPLIER'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ส่งซ่อมซัพพลายเออร์</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/RETURN_SUPPLIER" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_RETURN_SUPPLIER'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รับคืนจากซัพพลายเออร์</span>
                        </a>
                      </router-link>

                      <router-link to="/Jobs/Create/TRANSFER_TO_SHOP" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow(['JOB_ADMIN_TRANSFER_TO_SHOP'])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/TRANSFER_TO_MULTI_SHOP" tag="li" class="kt-menu__item" style="margin-top:10px;"
                       aria-haspopup="true" v-if="this.$root.canShow(['JOB_ADMIN_TRANSFER_TO_SHOP'])">
                          <a class="kt-menu__link">
                              <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                              </i>
                              <span class="kt-menu__link-text" style="font-size:14px;">ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า(หลายร้านค้า)</span>
                          </a>
                      </router-link>

                      <router-link to="/Jobs/Create/PICKUP" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_PICKUP'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">หยิบสินค้าขึ้นรถ (เร่ขาย)</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/RETURN" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          ['JOB_ADMIN_RETURN', 'COMPANY_PROFILE_TYPE_AGENT'],
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ส่งสินค้า/ทรัพย์สินคืนต้นทาง</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/EXCHANGE" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_EXCHANGE'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">โอนทรัพย์สิน</span>
                        </a>
                      </router-link>
                      <router-link to="/Jobs/Create/RETURN_ADHOC" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_RETURN'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รับคืนสินค้า/ทรัพย์สินจากลูกค้า</span>
                        </a>
                      </router-link>
                     <router-link to="/Jobs/Create/AUDIT_STOCK" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['super_admin', 'BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ตรวจสอบ STOCK</span>
                        </a>
                      </router-link>
                      <!-- CR-Job-Stock §6.1 Phase 1 — ใบงานตัดยอดคงค้าง (Write-off Outstanding Stock) -->
                      <router-link to="/Jobs/Create/WRITE_OFF_STOCK" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ตัดยอดคงค้าง</span>
                        </a>
                      </router-link>
                      <!-- <router-link
                        to="/Jobs/Create/INVALID_CHECK"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_QI',
                            'MANAGER_QI',
                            'USER_QI',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i
                            class="kt-menu__link-bullet kt-menu__link-bullet--dot"
                          >
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text"
                            >ตรวจสอบข้อมูลทรัพย์สินไม่ถูกต้อง</span
                          >
                        </a>
                      </router-link> -->
                      <!-- <router-link
                        to="/Jobs/Create/BORROW"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="this.$root.canShow(['JOB_ADMIN_BORROW', 'JOB_ADMIN_BORROW_PLANT'])"
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">เบิก/ยืมทรัพย์สินเบียร์สด</span>
                        </a>
                      </router-link> -->
                    </ul>
                  </div>
                </li>

                <router-link to="/Borrow" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                  this.$root.canShow([
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB',
                  ])
                ">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                            fill="#000000" fill-rule="nonzero"
                            transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) " />
                          <rect fill="#000000" opacity="0.3" x="5" y="20" width="15" height="2" rx="1" />
                        </g>
                      </svg> </span><span class="kt-menu__link-text">เบิก/ยืม ทรัพย์สิน</span>
                  </a>
                </router-link>

                <!-- CR-FormSummaryStock — พิมพ์เอกสารสรุปข้อมูล
                     เป็น "รายการหนึ่ง" ในหมวด "ใบงาน (Job)" ต่อจาก "เบิก/ยืม ทรัพย์สิน"
                     — ไม่ทำ section header ของตัวเอง เพื่อไม่ให้ sidebar มีหัวข้อหมวดเพิ่มโดยไม่จำเป็น
                     เงื่อนไขการแสดงผลคงเดิม: เห็นเมนูเฉพาะ user ที่ถูกผูกโปรไฟล์ "พิมพ์เอกสารสรุปข้อมูล" ไว้เท่านั้น
                     ผู้ดูแลระบบทั่วไป (รวม super_admin) ที่ยังไม่ผูกโปรไฟล์ จะไม่เห็น -->
                <!-- FS-123 (19/10/2026) — ชื่อเมนู "พิมพ์เอกสารสรุปข้อมูลทรัพย์สิน" · ไอคอนเครื่องพิมพ์สีเหลือง (fss-menu — CSS ท้ายไฟล์) -->
                <li
                  v-if="this.$root.hasFormSummaryStockProfile()"
                  class="kt-menu__item kt-menu__item--submenu fss-menu"
                  data-test="fss-menu"
                  aria-haspopup="true"
                  data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/PrintSummary'),
                  }"
                >
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <i class="la la-print" data-test="fss-menu-icon"></i>
                    </span>
                    <span class="kt-menu__link-text">พิมพ์เอกสารสรุปข้อมูลทรัพย์สิน</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">พิมพ์เอกสารสรุปข้อมูลทรัพย์สิน</span>
                        </span>
                      </li>
                      <router-link
                        to="/PrintSummary/Barcodes"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot"><span></span></i>
                          <span class="kt-menu__link-text">เอกสารสรุปสินค้าคงค้าง</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <!--
                  CR-QC-Hide-Menu-From-Role-User (2026-10-02)
                  เอา 'USER_QI' ออกจากหมวด "ข้อมูลคะแนนตัวแทนจำหน่าย" ทั้ง 3 จุด
                  (หัวหมวด · บันทึกคะแนน · รายงาน) เพื่อซ่อนจากบทบาท "พนักงาน"
                  ของโปรไฟล์ "งานตรวจสอบคุณภาพเบียร์สด" — เมนูลูกข้างในไม่มีตัวไหนรับ USER_QI อยู่แล้ว
                -->
                <!-- ย้ายจาก ข้อมูลคะแนนตัวแทนจำหน่าย -->
                <li class="kt-menu__section" v-if="
                  this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN','ADMIN_QI', 'MANAGER_QI','AGENT_REPORT','BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK', ]) && this.$root.hasAnyCompanyProfile()
                ">
                  <h4 class="kt-menu__section-text">
                    ข้อมูลคะแนนตัวแทนจำหน่าย
                  </h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>

                <li v-if="
                  this.$root.canShowExSuperAdmin(['ADMIN_QI', 'MANAGER_QI', 'AGENT_SCORE_ADMIN'])
                  && this.$root.hasAnyCompanyProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Qi'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">บันทึกคะแนน</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">จัดการคะแนนตัวแทนจำหน่าย</span>
                        </span>
                      </li>
                      <router-link to="/AgentScore/JobAgentScore" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการคะแนนตัวแทนจำหน่าย</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>
                <li v-if="
                  (this.$root.canShowExSuperAdmin(['ADMIN_QI', 'MANAGER_QI','AGENT_REPORT','BR_REPORT','BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK','AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile())
                  && this.$root.hasAnyCompanyProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Qi'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงาน</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                       <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงาน</span>
                        </span>
                      </li>
                       <router-link to="/Report/AgentScoreEvaluation" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile()">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text"> รายงานประเมินตัวแทนจำหน่ายเบียร์สด</span>
                        </a>
                      </router-link>

                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงาน</span>
                        </span>
                      </li>
                       <router-link to="/Report/JobAgentScore" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile()">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">คะแนนการทำระบบเบียร์สด</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/JobAgentAuditStock" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin(['BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK','AGENT_SCORE_ADMIN'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายงานตรวจสอบ STOCK ตัวแทนจำหน่าย</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/KegRotationScore" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายงานคะแนนถังคงค้าง(ผู้ดูแลระบบ)</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/KegRotationScoreAgent" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile()">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายงานคะแนนถังคงค้าง(ตัวแทนจำหน่าย)</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="this.$root.user.profile.role != 'QI_QIMAINTAIN' && !this.$root.hasBudgetPlanProfile()">
                  <h4 class="kt-menu__section-text">รายงาน (Report)</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>

                <!-- รายงานแอดมิน -->
                <li
                  v-if="this.$root.canShow(['']) && !this.$root.hasBudgetPlanProfile()"
                  class="kt-menu__item kt-menu__item--submenu"
                  aria-haspopup="true"
                  data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/AdminReport'),
                  }"
                >
                  <!--v-if="
                    this.$root.canShow([
                      'BR_REPORT',
                      'AGENT_REPORT',
                      'SUB_AGENT_REPORT',
                      'COOL_SERVICE_PM',
                    ])
                  "-->
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงานแอดมิน</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>

                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงานแอดมิน</span>
                        </span>
                      </li>

                      <!-- ข้อมูลร้านค้า -->
                      <!-- <router-link
                        to="/AdminReport/MasterShopOnOff"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="this.$root.canShow(['BR_REPORT', 'AGENT_REPORT'])"
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลร้านค้า</span>
                        </a>
                      </router-link> -->

                      <!-- ข้อมูลหัวจ่าย -->
                      <!-- <router-link
                        to="/AdminReport/BarButlerByBrand"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="this.$root.canShow(['BR_REPORT', 'AGENT_REPORT'])"
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i> -->
                          <!-- <span class="kt-menu__link-text"
                            >ข้อมูลหัวจ่ายแยกตามแบรนด์</span
                          > -->
                          <!-- <span class="kt-menu__link-text">ข้อมูลหัวจ่าย</span>
                        </a>
                      </router-link> -->

                      <!-- ข้อมูลการล้างเครื่องเบียร์สด (PM) -->
                      <!-- <router-link
                        to="/AdminReport/PM"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'AGENT_REPORT',
                            'SUB_AGENT_REPORT',
                            'BR_REPORT',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลการล้างเครื่องเบียร์สด (PM)</span>
                        </a>
                      </router-link> -->

                      <!-- จำนวนร้านค้าแยกตามแบรนด์ -->
                      <router-link
                        to="/AdminReport/MasterShopByBrand"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="this.$root.canShow([''])"
                      >
                        <!--v-if="this.$root.canShow(['BR_REPORT', 'AGENT_REPORT'])"-->
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จำนวนร้านค้าแยกตามแบรนด์</span>
                        </a>
                      </router-link>

                      <!-- Survey PM/MT/QC/MKT (ร้านค้า On/Off premise) -->
                      <!-- <router-link to="/AdminReport/Survey" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow([''])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Survey PM/MT/QC/MKT (ร้านค้า On/Off premise)</span>
                        </a>
                      </router-link> -->
                      

                      <!-- การแจ้งปัญหา -->
                      <router-link to="/AdminReport/JobIssue" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow([''])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">การแจ้งปัญหา</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <!-- รายงาน -->
                <li v-if="
                  this.$root.canShow([
                    'AGENT_REPORT',
                    'SUB_AGENT_REPORT',
                    'BR_REPORT',
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'LEAD_QIMAINTAIN'
                  ]) && !this.$root.hasBudgetPlanProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Report'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงาน</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงาน</span>
                        </span>
                      </li>
                    

                      <router-link to="/Report/JobRetrieve" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['AGENT_REPORT', 'BR_REPORT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รับคืนจากตัวแทนจำหน่าย</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/AssetProducts" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['BR_REPORT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">มูลค่าทรัพย์สิน</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/Movement" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ความเคลื่อนไหว</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/FixedProducts" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['BR_REPORT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ประวัติการซ่อมรายบาร์โค้ด</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/ProduceProducts" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['BR_REPORT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ประวัติการผลิตรายบาร์โค้ด</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/BrandCount" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ปิดใบงานตัวแทนและโรงงาน</span>
                        </a>
                      </router-link>
                      <router-link to="/Report/AgentAssets" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Stock สินค้ารายตัวแทนจำหน่าย</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/ShopAssets" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Stock สินค้ารายร้านค้า</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/TransferBarcode" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['AGENT_REPORT',])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/TransferBarcodeMultiple" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="this.$root.canShow(['AGENT_REPORT'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">
                            Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า(หลายร้าน)
                          </span>
                          <span class="kt-menu__link-text"></span>
                        </a>
                      </router-link>

                      <router-link to="/Report/TransferBarcodeSubAgent" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if=" this.$root.canShow(['SUB_AGENT_REPORT',])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">
                            Stock Card ระหว่างตัวแทนจำหน่ายย่อยกับร้านค้า
                          </span>
                          <span class="kt-menu__link-text"></span>
                        </a>
                      </router-link>

                      <router-link to="/Report/TransferBarcodeSupplier" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="this.$root.canShow([
                                   'BR_REPORT',
                                   'OFFICER_QIMAINTAIN',
                                   'OFFICER_PLANT_QIMAINTAIN',
                                   'LEAD_QIMAINTAIN'
                                   ])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ประวัติส่งซ่อม Supplier</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/Barcodes" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Stock รายบาร์โค้ด</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/AverageBarcode" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['BR_REPORT']) && false">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ค่าเฉลี่ยกระบวนการภายในโรงงาน/คลังสินค้า</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/BarcodeStatus" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">สถานะ</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/ProductStocks" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Stock เบิกยืมรายโควตา</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/Borrow" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">การเบิกยืมและยอดคงค้าง Excel</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/PaymentProduct" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">การจ่ายสินค้า</span>
                        </a>
                      </router-link>

                      <router-link to="/Report/ReturnProduct" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'BR_REPORT',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">การรับคืน</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <!-- รายงานการแจ้งเตือนคงค้างเกินกำหนด -->
                <li
                  v-if="this.$root.canShow([
                    'AGENT_REPORT',
                    'BR_REPORT',
                  ]) && !this.$root.hasBudgetPlanProfile()"
                  class="kt-menu__item kt-menu__item--submenu"
                  aria-haspopup="true"
                  data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/AlertReport'),
                  }"
                >
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงานการแจ้งเตือน</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">คงค้างเกินกำหนดเวลา</span>
                        </span>
                      </li>
                      <router-link
                        to="/AlertReport/BeforeDue" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['AGENT_REPORT','BR_REPORT'])"
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">คงค้างก่อนครบกำหนดการคืน</span>
                        </a>
                      </router-link>
                      <router-link
                        to="/AlertReport/OverdueAll" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['AGENT_REPORT','BR_REPORT'])"
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">คงค้างเลยกำหนดการคืน</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>  

                <!-- รายงาน QC -->
                <li v-if="
                  this.$root.canShow(['ADMIN_QI', 'MANAGER_QI', 'USER_QI', 'AGENT_REPORT', 'SUB_AGENT_REPORT']) && !this.$root.hasBudgetPlanProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/QIReport'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงาน QC</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงาน QC</span>
                        </span>
                      </li>
                      <router-link to="/QCReport/QCGroupByAgent" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_QI',
                            'MANAGER_QI',
                            'USER_QI',
                            'AGENT_REPORT',
                            'SUB_AGENT_REPORT',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">คะแนน QC Group by Agent</span>
                        </a>
                      </router-link>

                      <router-link to="/QCReport/QCGroupByOfficer" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_QI',
                            'MANAGER_QI',
                            'USER_QI',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">สรุปการเข้าทำ QC Group by เจ้าหน้าที่</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <!-- รายงาน   PM -->
                <li
                  v-if="
                    this.$root.canShow([
                      'ADMIN_PM',
                      'MANAGER_PM',
                      'AGENT_REPORT',
                      'COOL_SERVICE_PM',
                      'AGENT_ADMIN_PM',
                      'SUB_AGENT_ADMIN_PM',
                    ]) && !this.$root.hasBudgetPlanProfile()
                  "
                  class="kt-menu__item kt-menu__item--submenu"
                  aria-haspopup="true"
                  data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/PMReport'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงาน PM</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงาน PM</span>
                        </span>
                      </li>

                      <!-- Alert PM (เกินกำหนดการล้างเครื่อง) -->
                      <router-link to="/PMReport/AlertPM" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Alert PM (เกินกำหนดการล้างเครื่อง)</span>
                        </a>
                      </router-link>

                      <!-- ข้อมูลร้านค้า -->
                      <router-link
                        to="/PMReport/MasterShopOnOff"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i
                            class="kt-menu__link-bullet kt-menu__link-bullet--dot"
                          >
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลร้านค้า</span>
                        </a>
                      </router-link>

                      <!-- ข้อมูลหัวจ่าย -->
                      <router-link
                        to="/PMReport/BarButlerByBrand"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM', 'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i
                            class="kt-menu__link-bullet kt-menu__link-bullet--dot"
                          >
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลหัวจ่าย</span>
                        </a>
                      </router-link>

                      <!-- ข้อมูลการล้างเครื่องเบียร์สด (PM) -->
                      <router-link
                        to="/PMReport/PM"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i
                            class="kt-menu__link-bullet kt-menu__link-bullet--dot"
                          >
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text"
                            >ข้อมูลการล้างเครื่องเบียร์สด (PM)</span
                          >
                        </a>
                      </router-link>

                      <router-link to="/PMReport/PMOperationReport" tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM', 'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายงาน ปฏิทินบันทึกงาน PM</span>
                        </a>
                      </router-link>

                      <!-- รายงานจำนวนชุดอุปกรณ์ -->
                      <router-link
                        to="/PMReport/BarcodeMapping"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i
                            class="kt-menu__link-bullet kt-menu__link-bullet--dot"
                          >
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text"
                            >รายงานจำนวนชุดอุปกรณ์</span
                          >
                        </a>
                      </router-link>

                      <!-- ข้อมูลการ Survey PM -->
                      <router-link
                        to="/PMReport/PMSurvey"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i
                            class="kt-menu__link-bullet kt-menu__link-bullet--dot"
                          >
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text"
                            >ข้อมูลการ Survey PM</span
                          >
                        </a>
                      </router-link>

                      <!-- <router-link
                        to="/PMReport/PMMonthly"
                        tag="li"
                        class="kt-menu__item"
                        aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        "
                      >
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ผลสรุปการบำรุงรักษาเครื่อง (PM) ประจำเดือน</span>
                        </a>
                      </router-link>-->
                      <!-- <router-link to="/PMReport/MTMonthly" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM',
                          'COOL_SERVICE_PM',
                        ])
                      "> 
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ผลสรุปการซ่อมเครื่อง (MT) ประจำเดือน</span>
                        </a>
                      </router-link> -->
                      <!-- <router-link to="/PMReport/PMSpare" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM',
                          'COOL_SERVICE_PM',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">สรุปการใช้อะไหล่ในการบำรุงรักษาและการซ่อมเครื่อง</span>
                        </a>
                      </router-link> -->
                      <!-- <router-link to="/PMReport/PMRoutePlan" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM',
                          'COOL_SERVICE_PM',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ผลสรุปการบำรุงรักษาเครื่องตามแผนงาน</span>
                        </a>
                      </router-link> -->
                      <!-- <router-link to="/PMReport/PMAlertSummary" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ผลสรุปการแจ้งเตือน</span>
                        </a>
                      </router-link> -->
                    </ul>
                  </div>
                </li>

                <!-- รายงานการตลาด (MARKETING) -->
                <li v-if="
                  this.$root.canShow(['ADMIN_MKT', 'MANAGER_MKT', 'USER_MKT']) && !this.$root.hasBudgetPlanProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/MKTReport'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงานการตลาด</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงานการตลาด</span>
                        </span>
                      </li>
                      <router-link to="/MKTReport/EventAndFood" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Event/มหกรรมอาหาร</span>
                        </a>
                      </router-link>

                      <router-link to="/MKTReport/SurveyOnOffPremise" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ตรวจเยี่ยมร้าน On/Off-premise</span>
                        </a>
                      </router-link>

                      <router-link to="/MKTReport/NewShopOnOffPremise" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">เปิดร้านค้าใหม่ On/Off-premise</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>
                <!-- รายงาน 5ส -->
                <li v-if="
                  this.$root.canShow([
                    'ADMIN_5S',
                    'ADVISOR_5S',
                    'AGENT_REPORT',
                    'TEAM_5S',
                  ]) && !this.$root.hasBudgetPlanProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/5SReport'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงาน S+</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงาน S+</span>
                        </span>
                      </li>
                      <router-link to="/5SReport/TransactionView5S" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow(['ADMIN_5S', 'TEAM_5S'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จำนวนครั้งในการเข้าดูข้อมูลใน S+(E-Learning)</span>
                        </a>
                      </router-link>

                      <router-link to="/5SReport/EvaluateView5S" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_5S',
                            'ADVISOR_5S',
                            'AGENT_REPORT',
                            'TEAM_5S',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จำนวนการประเมินคะแนนประจำเดือน S+</span>
                        </a>
                      </router-link>

                      <router-link to="/5SReport/WarehouseScore" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_5S',
                            'ADVISOR_5S',
                            'AGENT_REPORT',
                            'TEAM_5S',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">คะแนนโครงการบริหารคลังสินค้าประจำเดือน</span>
                        </a>
                      </router-link>

                      <router-link to="/5SReport/NotificationKPI" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_5S',
                            'ADVISOR_5S',
                            'AGENT_REPORT',
                            'TEAM_5S',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายงานผลสรุปการแจ้งเตือนไม่ลงข้อมูล KPIs</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>
                <!-- รายงานเบียร์เคลม (BEERCLAIM) -->
                <li
                  v-if="
                    this.$root.canShow(['AGENT_REPORT', 'ADMIN_BEER_CLAIM','QI_OFFICER_BEER_CLAIM', 'PLANT_ACCOUNTANT_BEER_CLAIM', 'DB_OFFICER_BEER_CLAIM', 'LAB_BEER_CLAIM','ADMIN_PLANT_BEER_CLAIM','MANAGER_BEER_CLAIM']) && !this.$root.hasBudgetPlanProfile()
                  "
                  class="kt-menu__item kt-menu__item--submenu"
                  aria-haspopup="true"
                  data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/BeerClaimReport'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงานเบียร์เคลม</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงานเบียร์เคลม</span>
                        </span>
                      </li>
                      <router-link to="/BeerClaimReport/AmountBeerClaim" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'BR_REPORT',
                            'AGENT_REPORT',
                            'ADMIN_BEER_CLAIM',
                            'QI_OFFICER_BEER_CLAIM',
                            'PLANT_ACCOUNTANT_BEER_CLAIM',
                            'DB_OFFICER_BEER_CLAIM',
                            'LAB_BEER_CLAIM',
                            'ADMIN_PLANT_BEER_CLAIM',
                            'MANAGER_BEER_CLAIM'
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จำนวนการเคลมเบียร์ประจำเดือน</span>
                        </a>
                      </router-link>

                      <router-link to="/BeerClaimReport/StatusBeerClaimMonthly" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'BR_REPORT',
                            'AGENT_REPORT',
                            'ADMIN_BEER_CLAIM',
                            'QI_OFFICER_BEER_CLAIM',
                            'PLANT_ACCOUNTANT_BEER_CLAIM',
                            'DB_OFFICER_BEER_CLAIM',
                            'LAB_BEER_CLAIM',
                            'ADMIN_PLANT_BEER_CLAIM',
                            'MANAGER_BEER_CLAIM'
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">สถานะการเคลมคงค้างในกระบวนการประจำเดือน</span>
                        </a>
                      </router-link>

                      <router-link to="/BeerClaimReport/CostBeerClaim" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="this.$root.canShow(['', 'ADMIN_BEER_CLAIM','MANAGER_BEER_CLAIM'])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายจ่ายในการเคลมเบียร์ (รายปี)</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>
                <!-- รายงานช่างซ่อมบำรุง -->
                <li v-if="
                  this.$root.canShow([
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'CHECKER_QIMAINTAIN',
                    'LEAD_QIMAINTAIN',
                  ]) && !this.$root.hasBudgetPlanProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/MaintainReport'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงานช่างซ่อมบำรุง</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงานช่างซ่อมบำรุง</span>
                        </span>
                      </li>
                      <router-link to="/MaintainReport/StockPending" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN',
                          'OFFICER_PLANT_QIMAINTAIN',
                          'LEAD_QIMAINTAIN',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text" style="font-size:10pt;">Stock รอซ่อม/รอบำรุงรักษา/รอทำลาย/ส่งซ่อมซัพพลายเออร์</span>
                        </a>
                      </router-link>

                      <router-link to="/MaintainReport/Checker" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'CHECKER_QIMAINTAIN',
                            'LEAD_QIMAINTAIN',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ส่งมอบหลังซ่อม</span>
                        </a>
                      </router-link>

                      <router-link to="/MaintainReport/SparePartsUsed" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลการใช้อะไหล่เครื่อง/อุปกรณ์</span>
                        </a>
                      </router-link>

                      <router-link to="/MaintainReport/StockSpareParts" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Stock อะไหล่ทีมช่างซ่อมบำรุง</span>
                        </a>
                      </router-link>

                      <router-link to="/MaintainReport/Drawback" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายละเอียด Stock คลังช่าง</span>
                        </a>
                      </router-link>

                      <router-link to="/MaintainReport/RepairUsage" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จำนวนการซ่อมเครื่อง/อุปกรณ์</span>
                        </a>
                      </router-link>

                      <router-link to="/MaintainReport/RepairSum" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">มูลค่าซ่อม</span>
                        </a>
                      </router-link>

                      <router-link to="/MaintainReport/QISummary" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Summary</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>
                <!-- รายงานเครื่องเช่า -->
                <li v-if="
                  this.$root.canShow([
                    'ADMIN_EQUIPMENT_LEASING',
                    'USER_EQUIPMENT_LEASING',
                  ]) && !this.$root.hasBudgetPlanProfile()
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/MachineReport'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">รายงานเครื่องเช่า</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">รายงานเครื่องเช่า</span>
                        </span>
                      </li>
                      <router-link to="/MachineReport/Invoice" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_EQUIPMENT_LEASING',
                          'USER_EQUIPMENT_LEASING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">การวางบิล / การจ่ายเงิน</span>
                        </a>
                      </router-link>

                      <router-link to="/MachineReport/LeaseMachine" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">สรุปจำนวนเครื่องเช่า</span>
                        </a>
                      </router-link>

                      <router-link to="/MachineReport/MachineDetail" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายละเอียดเครื่องเช่า</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT',
                  ])
                ">
                  <h4 class="kt-menu__section-text">การตลาด (Marketing)</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li v-if="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT',
                  ])
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Marketing'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">การตลาด</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">การตลาด</span>
                        </span>
                      </li>
                      <router-link to="/Marketing/MarketingList" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="
                          this.$root.canShow([
                            'super_admin',
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลการตลาด</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="
                  this.$root.canShow([
                    'ADMIN_5S',
                    'ADVISOR_5S',
                    'AGENT_E-Learning',
                    'JOB_AGENT_KPI',
                    'TEAM_5S',
                  ])
                ">
                  <h4 class="kt-menu__section-text">
                    การบริหารคลังสินค้า งาน S+
                  </h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  v-if="
                    this.$root.canShow([
                      'ADMIN_5S',
                      'ADVISOR_5S',
                      'AGENT_E-Learning',
                      'JOB_AGENT_KPI',
                      'TEAM_5S',
                    ])
                  " :class="{
  'kt-menu__item--open': subIsActive('/5S'),
}">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">งาน S+</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">งาน S+</span>
                        </span>
                      </li>
                      <router-link to="/5S/E-Learning" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_5S',
                          'ADVISOR_5S',
                          'AGENT_E-Learning',
                          'TEAM_5S',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลการเรียนรู้ (E-Learning)</span>
                        </a>
                      </router-link>
                      <li class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true"
                        data-ktmenu-submenu-toggle="hover" v-if="
                          this.$root.canShow([
                            'ADMIN_5S',
                            'JOB_AGENT_KPI',
                            'ADVISOR_5S',
                            'TEAM_5S',
                          ])
                        " :class="{
  'kt-menu__item--open': subIsActive('/Kpi'),
}">
                        <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                          <span class="kt-menu__link-icon">
                            <svg class="kt-svg-icon" version="1.1" xmlns="http://www.w3.org/2000/svg"
                              width="24.000000pt" height="24.000000pt" viewBox="0 0 24.000000 24.000000"
                              preserveAspectRatio="xMidYMid meet">
                              <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)" stroke="none"
                                stroke-width="1">
                                <path d="M25 228 c-3 -8 -4 -61 -3 -119 l3 -104 77 -3 c115 -4 118 -2 118 119
                        0 71 -4 101 -12 104 -7 2 -50 6 -96 10 -65 5 -83 4 -87 -7z m175 -108 c0 -53
                        -4 -90 -10 -90 -5 0 -10 8 -10 18 0 10 -5 23 -12 30 -9 9 -9 12 0 12 7 0 12 5
                        12 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6
                        -9 10 -20 10 -11 0 -20 5 -20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 -13 10
                        -30 10 -16 0 -30 5 -30 10 0 6 18 10 40 10 l40 0 0 -90z" id="Combined-Shape" fill="#000000"
                                  opacity="0.3" />
                              </g>
                            </svg>
                          </span>
                          <span class="kt-menu__link-text">ข้อมูล KPI</span>
                          <i class="kt-menu__ver-arrow la la-angle-right"></i>
                        </a>
                        <div class="kt-menu__submenu">
                          <span class="kt-menu__arrow"></span>
                          <ul class="kt-menu__subnav">
                            <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                              <span class="kt-menu__link">
                                <span class="kt-menu__link-text">ข้อมูล KPI</span>
                              </span>
                            </li>
                            <router-link to="/Kpi/ProductSlow" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                              this.$root.canShow([
                                'ADMIN_5S',
                                'JOB_AGENT_KPI',
                                'ADVISOR_5S',
                                'TEAM_5S',
                              ])
                            ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">สินค้าเคลื่อนไหวช้า</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/ProductExpire" tag="li" class="kt-menu__item" aria-haspopup="true"
                              v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">สินค้าหมดอายุ</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/ProductLost" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                              this.$root.canShow([
                                'ADMIN_5S',
                                'JOB_AGENT_KPI',
                                'ADVISOR_5S',
                                'TEAM_5S',
                              ])
                            ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">สินค้าสูญหาย</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/ProductDilapidated" tag="li" class="kt-menu__item"
                              aria-haspopup="true" v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">สินค้าที่ชำรุดเสียหาย</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/AccessoriesLost" tag="li" class="kt-menu__item" aria-haspopup="true"
                              v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">อุปกรณ์ส่งเสริมสูญหาย</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/ProductCycle" tag="li" class="kt-menu__item" aria-haspopup="true"
                              v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">ถังเปล่าหมุนเวียน</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/DamageMach" tag="li" class="kt-menu__item" aria-haspopup="true"
                              v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">เครื่องเบียร์สดชำรุด</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/LostMach" tag="li" class="kt-menu__item" aria-haspopup="true"
                              v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">เครื่องเบียร์สดสูญหาย</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/AccessoriesDilapidated" tag="li" class="kt-menu__item"
                              aria-haspopup="true" v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">อุปกรณ์เบียร์สดสูญหาย</span>
                              </a>
                            </router-link>
                            <router-link to="/Kpi/LostTank" tag="li" class="kt-menu__item"
                              aria-haspopup="true" v-if="
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S',
                                ])
                              ">
                              <a class="kt-menu__link">
                                <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                  <span></span>
                                </i>
                                <span class="kt-menu__link-text">ถังเปล่า/Co2 สูญหาย</span>
                              </a>
                            </router-link>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="
                  this.$root.canShow([
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM',
                    'SUB_AGENT_ADMIN_PM', 
                  ])
                ">
                  <h4 class="kt-menu__section-text">
                    งานล้างเครื่องเบียร์สด (PM)
                  </h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li v-if="
                  this.$root.canShow([
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM', 
                  ])
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/PM'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">PM</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">PM</span>
                        </span>
                      </li>
                      <router-link to="/PM/PMRoutePlan" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM', 
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการ Route Plan/Adhoc</span>
                        </a>
                      </router-link>
                      <router-link to="/PM/PMCheckIn" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM',,'SUB_AGENT_ADMIN_PM', 
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูล Check-in/out PM</span>
                        </a>
                      </router-link>
                      <router-link to="/PM/PMSurveyCheckIn" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM',,'SUB_AGENT_ADMIN_PM', 
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูล Survey PM</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="
                  this.$root.canShow([
                    'ADMIN_BEER_CLAIM',
                    'QI_OFFICER_BEER_CLAIM',
                    'PLANT_ACCOUNTANT_BEER_CLAIM',
                    'LAB_BEER_CLAIM',
                    'AGENT_ADMIN_BEER_CLAIM',
                    'ADMIN_PLANT_BEER_CLAIM',
                    'MANAGER_BEER_CLAIM',
                    'DB_OFFICER_BEER_CLAIM'
                  ])
                ">
                  <h4 class="kt-menu__section-text">เบียร์เคลม (BeerClaim)</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li v-if="
                  this.$root.canShow([
                    'ADMIN_BEER_CLAIM',
                    'MANAGER_BEER_CLAIM',
                    'QI_OFFICER_BEER_CLAIM',
                    'PLANT_ACCOUNTANT_BEER_CLAIM',
                    'LAB_BEER_CLAIM',
                    'AGENT_ADMIN_BEER_CLAIM',
                    'ADMIN_PLANT_BEER_CLAIM',
                  ])
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/BeerClaim'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">เบียร์เคลม</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">เบียร์เคลม</span>
                        </span>
                      </li>
                      <router-link to="/BeerClaim/Claim" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_BEER_CLAIM',
                          'MANAGER_BEER_CLAIM',
                          'QI_OFFICER_BEER_CLAIM',
                          'PLANT_ACCOUNTANT_BEER_CLAIM',
                          'LAB_BEER_CLAIM',
                          'AGENT_ADMIN_BEER_CLAIM',
                          'ADMIN_PLANT_BEER_CLAIM',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">แจ้งเคลมเบียร์</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="
                  this.$root.canShow([
                    'OFFICER_QIMAINTAIN', 
                    'OFFICER_PLANT_QIMAINTAIN', 
                    'LEAD_QIMAINTAIN', 
                    'QI_QIMAINTAIN'])
                ">
                  <h4 class="kt-menu__section-text">งานช่างซ่อมบำรุง</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <router-link to="/Maintain/Stock" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="this.$root.user.profile.role == 'QI_QIMAINTAIN'">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                            fill="#000000" fill-rule="nonzero"
                            transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) " />
                          <rect fill="#000000" opacity="0.3" x="5" y="20" width="15" height="2" rx="1" />
                        </g>
                      </svg> </span><span class="kt-menu__link-text">อะไหล่คงเหลือรายช่างซ่อม</span>
                  </a>
                </router-link>
                <li v-if="
                  this.$root.canShow(['OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'])
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Maintain'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">งานช่างซ่อมบำรุง</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">งานช่างซ่อมบำรุง</span>
                        </span>
                      </li>
                      <router-link to="/Maintain/QIJob" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ใบงานช่างซ่อม</span>
                        </a>
                      </router-link>
                      <router-link to="/Maintain/Recv" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รับเข้าอะไหล่</span>
                        </a>
                      </router-link>
                      <router-link to="/Maintain/Stock" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">อะไหล่คงเหลือรายช่างซ่อม</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="
                  this.$root.canShow([
                    'ADMIN_EQUIPMENT_LEASING',
                    'USER_EQUIPMENT_LEASING',
                  ])
                ">
                  <h4 class="kt-menu__section-text">งานเครื่องเช่า</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li v-if="
                  this.$root.canShow([
                    'ADMIN_EQUIPMENT_LEASING',
                    'USER_EQUIPMENT_LEASING',
                  ])
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Machin'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">เครื่องเช่า</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">เครื่องเช่า</span>
                        </span>
                      </li>
                      <router-link to="/Machine/ListMachine" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_EQUIPMENT_LEASING',
                          'USER_EQUIPMENT_LEASING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ข้อมูลเครื่องเช่า</span>
                        </a>
                      </router-link>
                      <router-link to="/Machine/ManagePhase" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_EQUIPMENT_LEASING',
                          'USER_EQUIPMENT_LEASING',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล Phase</span>
                        </a>
                      </router-link>
                      <router-link to="/Machine/ManageMachineTransaction" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล เครื่องเช่า</span>
                        </a>
                      </router-link>
                      <router-link to="/Machine/SaveBillingMachinePayment" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">บันทึกข้อมูลการวางบิล</span>
                        </a>
                      </router-link>

                      <router-link to="/Machine/PaymentMachinePayment" tag="li" class="kt-menu__item"
                        aria-haspopup="true" v-if="
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING',
                          ])
                        ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">บันทึกชำระเงินเครื่องเช่า</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <li class="kt-menu__section" v-if="
                  this.$root.canShow(['ADMIN_QI', 'MANAGER_QI', 'USER_QI'])
                ">
                  <h4 class="kt-menu__section-text">
                    งานตรวจสอบคุณภาพเบียร์สด (QC)
                  </h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li v-if="
                  this.$root.canShow(['ADMIN_QI', 'MANAGER_QI', 'USER_QI'])
                " class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{
                    'kt-menu__item--open': subIsActive('/Qi'),
                  }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                            id="Combined-Shape" fill="#000000" opacity="0.3" />
                          <path
                            d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                            id="Combined-Shape" fill="#000000" />
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">QC</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">QC</span>
                        </span>
                      </li>
                      <router-link to="/QC/QCCheckIn" tag="li" class="kt-menu__item" aria-haspopup="true" v-if="
                        this.$root.canShow([
                          'ADMIN_QI',
                          'MANAGER_QI',
                          'USER_QI',
                        ])
                      ">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">เช็คอินร้านค้า</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <!-- Budget Plan Section -->
                <li class="kt-menu__section" v-if="this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']])">
                  <h4 class="kt-menu__section-text">งบประมาณ (Budget Approval)</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li v-if="this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']])"
                  class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{ 'kt-menu__item--open': subIsActive('/BudgetPlan') }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path d="M2,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,17 C22,17.5522847 21.5522847,18 21,18 L2,18 C1.44771525,18 1,17.5522847 1,17 L1,7 C1,6.44771525 1.44771525,6 2,6 Z M11.5,16 C13.709139,16 15.5,14.209139 15.5,12 C15.5,9.790861 13.709139,8 11.5,8 C9.290861,8 7.5,9.790861 7.5,12 C7.5,14.209139 9.290861,16 11.5,16 Z" fill="#000000" opacity="0.3"/>
                          <path d="M4,12 L3,12 C2.44771525,12 2,11.5522847 2,11 C2,10.4477153 2.44771525,10 3,10 L4,10 C4.55228475,10 5,10.4477153 5,11 C5,11.5522847 4.55228475,12 4,12 Z M20,12 L19,12 C18.4477153,12 18,11.5522847 18,11 C18,10.4477153 18.4477153,10 19,10 L20,10 C20.5522847,10 21,10.4477153 21,11 C21,11.5522847 20.5522847,12 20,12 Z" fill="#000000"/>
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">Budget Approval</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">Budget Approval</span>
                        </span>
                      </li>
                      <router-link to="/BudgetPlan/Job" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">ใบงาน Budget</span>
                        </a>
                      </router-link>
                      <router-link to="/BudgetPlan/List" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล CCTR/IO/GL</span>
                        </a>
                      </router-link>
                      <router-link to="/BudgetPlan/ApproveGroup" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin([['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูลผู้อนุมัติ</span>
                        </a>
                      </router-link>
                      <!-- ISS-30/31 (7 ต.ค. 2026 · QA BUG-02a/02b)
                           ย้ายมาจาก section "รายงาน" ที่แยกอยู่ข้างนอก (ลบ section นั้นทิ้งแล้ว)
                           และตัดคำว่า "รายงาน" นำหน้าออก ให้ตรงกับชื่อรายงานในสเปก -->
                      <router-link to="/BudgetPlan/Report/Vendor" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']])">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">รายละเอียดใช้งบประมาณตาม Vendor</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

                <!-- Stock Cover Days Section -->
                <li class="kt-menu__section" v-if="this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile())">
                  <h4 class="kt-menu__section-text">Stock Cover Days</h4>
                  <i class="kt-menu__section-icon flaticon-more-v2"></i>
                </li>
                <li v-if="this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile())"
                  class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                  :class="{ 'kt-menu__item--open': subIsActive('/StockCoverDays') }">
                  <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
                    <span class="kt-menu__link-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path d="M2,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,17 C22,17.5522847 21.5522847,18 21,18 L2,18 C1.44771525,18 1,17.5522847 1,17 L1,7 C1,6.44771525 1.44771525,6 2,6 Z M11.5,16 C13.709139,16 15.5,14.209139 15.5,12 C15.5,9.790861 13.709139,8 11.5,8 C9.290861,8 7.5,9.790861 7.5,12 C7.5,14.209139 9.290861,16 11.5,16 Z" fill="#000000" opacity="0.3"/>
                          <path d="M4,12 L3,12 C2.44771525,12 2,11.5522847 2,11 C2,10.4477153 2.44771525,10 3,10 L4,10 C4.55228475,10 5,10.4477153 5,11 C5,11.5522847 4.55228475,12 4,12 Z M20,12 L19,12 C18.4477153,12 18,11.5522847 18,11 C18,10.4477153 18.4477153,10 19,10 L20,10 C20.5522847,10 21,10.4477153 21,11 C21,11.5522847 20.5522847,12 20,12 Z" fill="#000000"/>
                        </g>
                      </svg>
                    </span>
                    <span class="kt-menu__link-text">Stock Cover Days</span>
                    <i class="kt-menu__ver-arrow la la-angle-right"></i>
                  </a>
                  <div class="kt-menu__submenu">
                    <span class="kt-menu__arrow"></span>
                    <ul class="kt-menu__subnav">
                      <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
                        <span class="kt-menu__link">
                          <span class="kt-menu__link-text">Stock Cover Days</span>
                        </span>
                      </li>
                      <router-link to="/StockCoverDays/List" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile())">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">จัดการข้อมูล Stock Cover Days</span>
                        </a>
                      </router-link>
                      <!-- CR-StockCoverDays Feature 2 — Report Analysis (mirror Master gating; super_admin sees it) -->
                      <router-link to="/StockCoverDays/ReportAnalysis" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile())">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Report Analysis</span>
                        </a>
                      </router-link>
                      <!-- CR-StockCoverDays Feature 3 — Dashboard (แดชบอร์ดผู้บริหาร; mirror Master gating; super_admin sees it) -->
                      <router-link to="/StockCoverDays/Dashboard" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile())">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Dashboard</span>
                        </a>
                      </router-link>
                      <!-- CR-StockCoverDays Feature 4 — Stock Cover Days Report / Action Plan (Q-R1: เมนูแยกที่ 4; mirror Master gating; super_admin sees it) -->
                      <router-link to="/StockCoverDays/Report" tag="li" class="kt-menu__item" aria-haspopup="true"
                        v-if="this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile())">
                        <a class="kt-menu__link">
                          <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                            <span></span>
                          </i>
                          <span class="kt-menu__link-text">Stock Cover Days Report</span>
                        </a>
                      </router-link>
                    </ul>
                  </div>
                </li>

              </ul>
            </div>
          </div>

          <!-- end:: Aside Menu -->
        </div>
        <!-- end:: Aside -->
        <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
          <!-- begin:: Header -->
          <div id="kt_header" class="kt-header kt-grid__item kt-header--fixed">
            <!-- begin:: Header Menu -->
            <button class="kt-header-menu-wrapper-close" id="kt_header_menu_mobile_close_btn">
              <i class="la la-close"></i>
            </button>
            <div class="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
              <div id="kt_header_menu" class="kt-header-menu kt-header-menu-mobile kt-header-menu--layout-default">
                <ul class="kt-menu__nav"></ul>
              </div>
            </div>

            <!-- end:: Header Menu -->
            <!-- begin:: Header Topbar -->
            <div class="kt-header__topbar">
              <!--begin: Language bar -->
              <!--<div class="kt-header__topbar-item kt-header__topbar-item--langs">
                                              <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="10px,0px">
                                                  <span class="kt-header__topbar-icon">
                                                      <img class="" src="/themes/metronic/assets/media/flags/020-flag.svg" alt="" />
                                                  </span>
                                              </div>
                                              <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
                                                  <ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
                                                      <li class="kt-nav__item kt-nav__item--active">
                                                          <a href="#" class="kt-nav__link">
                                                              <span class="kt-nav__link-icon"><img src="/themes/metronic/assets/media/flags/020-flag.svg" alt="" /></span>
                                                              <span class="kt-nav__link-text">English</span>
                                                          </a>
                                                      </li>
                                                      <li class="kt-nav__item">
                                                          <a href="#" class="kt-nav__link">
                                                              <span class="kt-nav__link-icon"><img src="/themes/metronic/assets/media/flags/016-spain.svg" alt="" /></span>
                                                              <span class="kt-nav__link-text">Spanish</span>
                                                          </a>
                                                      </li>
                                                      <li class="kt-nav__item">
                                                          <a href="#" class="kt-nav__link">
                                                              <span class="kt-nav__link-icon"><img src="/themes/metronic/assets/media/flags/017-germany.svg" alt="" /></span>
                                                              <span class="kt-nav__link-text">German</span>
                                                          </a>
                                                      </li>
                                                  </ul>
                                              </div>
              </div>-->
              <!--end: Language bar -->
              <!--begin: User Bar -->
              <div class="kt-header__topbar-item kt-header__topbar-item--user" v-if="this.$root.user">
                <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="0px,0px">
                  <div class="kt-header__topbar-user">
                    <span class="kt-header__topbar-welcome kt-hidden-mobile">สวัสดี คุณ</span>
                    <span class="kt-header__topbar-username kt-hidden-mobile">
                      {{ this.$root.user.profile.name }}
                    </span>
                    <!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
                    <span
                      class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">
                      {{ this.$root.user.profile.name.charAt(0).toUpperCase() }}
                    </span>
                  </div>
                </div>
                <div
                  class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
                  <!--begin: Head -->
                  <div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                    style="background-image: url(/themes/metronic/assets/media/misc/bg-1.jpg)">
                    <div class="kt-user-card__avatar">
                      <img class="kt-hidden" alt="Pic" src="/themes/metronic/assets/media/users/300_25.jpg" />

                      <!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
                      <span class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                        {{
                            this.$root.user.profile.name.charAt(0).toUpperCase()
                        }}
                      </span>
                    </div>
                    <div class="kt-user-card__name">
                      {{ this.$root.user.profile.name }}
                    </div>
                  </div>

                  <!--end: Head -->
                  <!--begin: Navigation -->
                  <div class="kt-notification">
                    <div class="kt-notification__custom">
                      <a @click.prevent="signOut()" href="#" target="_blank"
                        class="btn btn-label-brand btn-sm btn-bold">ออกจากระบบ</a>
                    </div>
                  </div>

                  <!--end: Navigation -->
                </div>
              </div>

              <!--end: User Bar -->
            </div>

            <!-- end:: Header Topbar -->
          </div>
          <!-- end:: Header -->

          <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
            <!-- begin:: Subheader -->
            <div class="kt-subheader kt-grid__item" id="kt_subheader">
              <div class="kt-subheader__main">
                <h3 class="kt-subheader__title">
                  {{ this.$root.siteConfig.SiteName }}
                </h3>
                <span class="kt-subheader__separator kt-hidden"></span>
                <template v-if="($route.path === '/' || $route.path === '/AgentScoreDashboard' || $route.path === '/AgentStockOverdue')">
                  <div class="kt-subheader__breadcrumbs">
                    <template >
                      <router-link to="/" class="kt-subheader__breadcrumbs-home"><i class="flaticon2-shelter"></i></router-link>
                      <span class="kt-subheader__breadcrumbs-separator"></span>
                      <router-link v-if="this.$root.canShowExSuperAdmin(['super_admin'])" to="/" class="kt-subheader__breadcrumbs-link" :style="$route.path === '/' ? 'font-weight:bold;color:#5867dd' : ''">รายงาน Stock รายบาร์โค้ด</router-link>
                      <span class="kt-subheader__breadcrumbs-separator"></span>
                    </template>
                    <router-link to="/AgentScoreDashboard" v-if="this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN'])" class="kt-subheader__breadcrumbs-link" :style="$route.path === '/AgentScoreDashboard' ? 'font-weight:bold;color:#5867dd' : ''"><i class="la la-trophy"></i> คะแนนตัวแทนจำหน่าย</router-link>
                    <router-link to="/AgentStockOverdue" v-if="this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN', 'BR_DASHBOARD_AUDIT_STOCK'])" class="kt-subheader__breadcrumbs-link" :style="$route.path === '/AgentStockOverdue' ? 'font-weight:bold;color:#5867dd' : ''"><i class="la la-table"></i> รายงาน STOCK ระบบเบียร์สด</router-link>
                  </div>
                </template>
                <breadcrumbs v-else />
              </div>
            </div>
            <!-- end:: Subheader -->
            <!-- begin:: Content -->
            <div class="kt-content kt-grid__item kt-grid__item--fluid" id="kt_content">
              <div class="row">
                <div class="col-xl-12">
                  <router-view v-if="ready"></router-view>
                </div>
              </div>
            </div>
            <!-- end:: Content -->
          </div>

          <!-- begin:: Footer -->
          <div class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop">
            <div class="kt-footer__copyright">
              2019&nbsp;&copy;&nbsp;{{ this.$root.siteConfig.SiteName }}
            </div>
          </div>
          <!-- end:: Footer -->
        </div>
      </div>
    </div>
    <!-- end:: Page -->

    <!-- begin::Scrolltop -->
    <div id="kt_scrolltop" class="kt-scrolltop">
      <i class="fa fa-arrow-up"></i>
    </div>
    <!-- <notifications position="bottom right" group="foo" classes="my-style" /> -->
    <!-- <notifications group="foo" :width="500" position="top  center">
      <template slot="body" slot-scope="props">
        <div class="my-style">
          <div class="my-style-icon">
          </div>
          <div class="my-style-content">
            <div class="my-style-title">
              {{ props.item.title }}
            </div>
            <div class="my-style-text" v-html="props.item.text"></div>
          </div>
          <div class="my-style-close" @click="props.close">
            <i class="la la-close"></i>
          </div>
        </div>
      </template>
    </notifications> -->
    <!-- Custom style example -->

    <!-- end::Scrolltop -->
    <div
      class="modal fade"
      id="checkTimeoutModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="checkTimeoutModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h5 class="mt-3 mb-5">เนื่องจากการตรวจสอบของระบบ ไม่พบการใช้งานเกิน 30 นาที กรุณา Login ใหม่อีกครั้ง</h5>
            <button type="button" class="btn btn-primary mb-3" @click="handleOkClick">ตกลง</button>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import router from "./router";
import axios from "axios";

window.$ = window.jQuery = window.jquery = require("jquery");

export default {
  data: function () {
    return {
      ready: false,
      NotificationTitle: "",
      NotificationTBody: "",
      IsNotification: false,
      logoutTimer: null,
      checkTime: 0,
      maxCheckTime: process.env.EXPTIME,
      hiddenTime: 0,
      hiddenCheckInterval: 1000, // 1 second
    };
  },
  methods: {
    // CR-StockCoverDays (QA BUG-02): ซ่อนหัวข้อเมนู (kt-menu__section) ที่ไม่มีเมนูย่อยที่ user เข้าได้เลย
    // นับเฉพาะลิงก์ปลายทาง (a.kt-menu__link ที่ไม่ใช่ตัวเปิด submenu) ระหว่างหัวข้อนี้กับหัวข้อถัดไป —
    // เมนูที่ไม่มีสิทธิ์ถูก v-if ตัดออกจาก DOM แล้ว จึงไม่ต้องรู้เงื่อนไขสิทธิ์ของแต่ละเมนู
    syncMenuSections() {
      var nav = this.$el && this.$el.querySelector ? this.$el.querySelector("#kt_aside_menu .kt-menu__nav") : null;
      if (!nav) return;
      var sections = nav.querySelectorAll(":scope > li.kt-menu__section");
      for (var i = 0; i < sections.length; i++) {
        var hasItem = false;
        for (var el = sections[i].nextElementSibling; el && !el.classList.contains("kt-menu__section"); el = el.nextElementSibling) {
          if (el.querySelector("a.kt-menu__link:not(.kt-menu__toggle)")) {
            hasItem = true;
            break;
          }
        }
        sections[i].style.display = hasItem ? "" : "none";
      }
    },
    /**
     * QA 08/10/2026 (CR-FormSummaryStock) เรื่องที่ 2
     *   หัวข้อกลุ่มเมนู เช่น "รายงาน (Report)" แสดงอยู่แม้ไม่มีเมนูย่อยสักตัวใต้มัน
     *   เพราะ v-if ของหัวข้อกับของเมนูย่อยแต่ละตัวเป็นคนละเงื่อนไขกัน
     *   ผู้ใช้จึงเห็นหัวข้อลอย ๆ กดอะไรไม่ได้
     *
     *   แก้แบบกลาง: ไล่ดูทุก .kt-menu__section ว่ามีเมนูที่มองเห็นได้คั่นอยู่ก่อนถึง
     *   section ถัดไปหรือไม่ ถ้าไม่มีก็ซ่อนหัวข้อนั้น
     *
     *   เลือกวิธีนี้แทนการไปไล่แก้ v-if ของหัวข้อทีละอัน เพราะเมนูย่อยใต้แต่ละหัวข้อ
     *   เป็นของหลายทีม/หลาย CR การรวมเงื่อนไขด้วยมือเสี่ยงทำเมนูของทีมอื่นหาย
     *   วิธีนี้ไม่แตะ v-if ของใครเลย และครอบทุกหัวข้อโดยอัตโนมัติ
     */
    hideEmptyMenuSections() {
      this.$nextTick(function () {
        var nav = document.querySelector('#kt_aside_menu .kt-menu__nav');
        if (!nav) return;

        var children = Array.prototype.slice.call(nav.children);

        // FS-137 (BUG-15 · 21/10/2026): <li> ใน sidebar ไม่มี key → Vue reuse DOM node ตอน re-render
        //   display:none ที่ตั้งให้ "หัวข้อ" (ฟังก์ชันนี้ / syncMenuSections) จึงติดไปกับ "เมนู" ได้
        //   แล้ว offsetParent ของเมนูเป็น null → หัวข้อถูกซ่อนซ้ำทุกรอบ (เมนูหายถาวรหลัง F5)
        //   ฟังก์ชันนี้ตั้ง display ได้เฉพาะหัวข้อ และ li ระดับบนของ sidebar ไม่มี v-show / inline display
        //   จาก markup → ล้างค่าที่ค้างบน li อื่นก่อนคำนวณ
        children.forEach(function (node) {
          if (node.className.indexOf('kt-menu__section') < 0 && node.style.display === 'none') {
            node.style.display = '';
          }
        });

        children.forEach(function (node, index) {
          if (node.className.indexOf('kt-menu__section') < 0) return;

          var hasVisibleItem = false;

          for (var i = index + 1; i < children.length; i++) {
            var next = children[i];

            // ถึงหัวข้อถัดไปแล้ว = จบขอบเขตของหัวข้อนี้
            if (next.className.indexOf('kt-menu__section') >= 0) break;

            // v-if ที่เป็นเท็จจะไม่มี element อยู่ใน DOM เลย
            // ที่เหลือจึงเช็คแค่ว่าไม่ได้ถูกซ่อนด้วย CSS
            if (next.className.indexOf('kt-menu__item') >= 0 &&
                next.offsetParent !== null) {
              hasVisibleItem = true;
              break;
            }
          }

          node.style.display = hasVisibleItem ? '' : 'none';
        });
      });
    },

    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
      signOut() {
          // #65: ไม่ logout ICT SSO — ลบ local token เท่านั้น
          // เพื่อให้ ICT user กด login กลับมาได้โดยไม่ต้องกรอก password
          this.$root.signOut();
    },
    companyChange(e) { },
    startCheckTimer() {
      this.clearTimer();
      this.logoutTimer = setInterval(() => {
        this.checkTime += 1000;
        if (this.checkTime >= this.maxCheckTime) {
          this.showCheckTimeoutModal();
        }
      }, 1000);
    },
    resetTimer() {
      this.checkTime = 0;
      localStorage.setItem('lastActiveTime', Date.now());
    },
    clearTimer() {
      if (this.logoutTimer) {
        clearInterval(this.logoutTimer);
        this.logoutTimer = null;
      }
      if (this.hiddenTimer) {
        clearInterval(this.hiddenTimer);
        this.hiddenTimer = null;
      }
    },
    showCheckTimeoutModal() {
      this.clearTimer();
      localStorage.setItem('showCheckTimeoutModal', 'true');
      $('#checkTimeoutModal').modal('show');
    },
    handleOkClick() {
      // #64: idle timeout → ลบ local token เท่านั้น ไม่ logout ICT SSO
      // เพื่อให้ auto-login กลับมาได้โดยไม่ต้องกรอก password ใหม่
      $('#checkTimeoutModal').modal('hide');
      localStorage.removeItem('showCheckTimeoutModal');
      localStorage.setItem('triggerLogout', Date.now());
      // ใช้ removeUser() แทน signOut() เพื่อไม่ redirect ไป ADFS signout
      this.$root.mgr.removeUser().then(() => {
        window.location.href = '/Account/Login';
      });
    },
    handleStorageChange(event) {
      if (event.key === 'lastActiveTime' && event.newValue) {
        this.resetTimer();
      } else if (event.key === 'showCheckTimeoutModal' && event.newValue === 'true') {
        this.showCheckTimeoutModal();
      } else if (event.key === 'showCheckTimeoutModal' && event.newValue === null) {
        $('#checkTimeoutModal').modal('hide');
      } else if (event.key === 'triggerLogout' && event.newValue) {
        // #67: cross-tab idle timeout → ใช้ removeUser() เหมือน tab หลัก (ไม่ logout ICT SSO)
        this.$root.mgr.removeUser().then(() => {
          window.location.href = '/Account/Login';
        });
      }
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.hiddenTime = Date.now();
        this.hiddenTimer = setInterval(() => {
          const now = Date.now();
          const hiddenDuration = now - this.hiddenTime;
          this.checkTime += hiddenDuration;
          this.hiddenTime = now;
          if (this.checkTime >= this.maxCheckTime) {
            this.showCheckTimeoutModal();
          }
        }, this.hiddenCheckInterval);
      } else {
        if (this.hiddenTimer) {
          clearInterval(this.hiddenTimer);
          this.hiddenTimer = null;
        }
        this.hiddenTime = 0;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.resetTimer);
    window.removeEventListener('keydown', this.resetTimer);
    window.removeEventListener('click', this.resetTimer);
    window.removeEventListener('storage', this.handleStorageChange);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.clearTimer();
  },
  async mounted() {
    var self = this;
    var alertStep = [];
    var currentStep;

    await self.$root.authenticate(self.$route.path);

    // โหลด profiles ก่อนเช็ค redirect — ป้องกัน race condition
    // (เดิม profiles จะถูกโหลดทีหลังใน loadScript chain ทำให้ hasBrProfile() คืน false ผิดๆ)
    if (self.$root.isAuthenticated) {
      await self.$root.loadProfiles();
    }

    // หมายเหตุ: redirect "/" → "/AgentScoreDashboard" สำหรับ AGENT_REPORT/BR_REPORT
    // ถูกจัดการใน router.beforeEach (index.js) แล้ว — ไม่ทำซ้ำที่นี่ เพราะ early return
    // จะข้าม script-chain ที่ตั้งค่า self.ready = true ทำให้ <router-view v-if="ready">
    // ไม่ render หลังเข้าระบบครั้งแรก (ต้อง refresh หน้า)

    if (
      self.$root.isAuthenticated &&
      !(await self.$root.canAccessPage(self.$route))
    ) {
      // ISS-36 (CR-BudgetReport · QA BUG-01) เปิด "/" ใหม่ทั้งหน้าขณะ login อยู่ (แท็บใหม่ / refresh)
      // router นำทางครั้งแรกก่อน beforeEach ใน index.js ถูกผูก จึงมาตัดสินที่นี่ — user budget ไปใบงานแทน
      const landing = self.$route.path === "/" ? await self.$root.budgetLandingPath() : null;
      router.push({
        path: landing || "/Error/Unauthorized",
      });
    }

    self
      .$loadScript("/themes/metronic/assets/vendors/base/vendors.bundle.js")
      .then(() => {
         self
          .$loadScript(
            "/themes/metronic/assets/demo/default/base/scripts.bundle.js"
          )
          .then(() => {
            self
              .$loadScript("/themes/metronic/assets/app/bundle/app.bundle.js")
              .then( async () => {
                self
                  .$loadScript(
                    "/themes/metronic/assets/app/custom/general/crud/forms/widgets/bootstrap-datepicker.js"
                  )
                  .then( async () => {
                    //self.$loadScript("/js/setting.js").then(() => {
                    $(document).on("show.bs.modal", ".modal", function () {
                      var zIndex = 1040 + 10 * $(".modal:visible").length;
                      $(self).css("z-index", zIndex);
                      setTimeout(function () {
                        $(".modal-backdrop")
                          .not(".modal-stack")
                          .css("z-index", zIndex - 1)
                          .addClass("modal-stack");
                      }, 0);
                    });

                    // Set custom validator methods
                    $.validator.addMethod(
                      "regex",
                      function (value, element, regexp) {
                        var re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                      },
                      "Please check your input."
                    );

                    $.validator.addMethod(
                      "emailNullable",
                      function (value, ele) {
                        var val = $(ele).val();
                        var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
                        return !val || pattern.test(val);
                      },
                      "Invalid email format"
                    );

                    await axios.get("/Api/CompanyProfile/GetMyProfiles")
                      .then(function(response) {
                        if (response.status == 200) {
                          self.$root.profiles = response.data;
                          $.ready();
                          self.ready = true;

                          // if (response.data[0].isNotification) {
                          //   if (response.data[0].notificationBody !== null && response.data[0].notificationTitle !== null) {
                          //     Swal.fire({
                          //       title: response.data[0].notificationTitle,
                          //       html:
                          //         '<p style="text-align: left;">' +
                          //         response.data[0].notificationBody +
                          //         "</p>",
                          //       icon: "warning",
                          //     });
                          //   }

                          //   else if (response.data[0].notificationTitle2 !== null) {
                          //     Swal.fire({
                          //       title: response.data[0].notificationTitle2,
                          //       html:
                          //         '<p style="text-align: left;">' +
                          //         response.data[0].notificationBody2 +
                          //         "</p>",
                          //       icon: "warning",
                          //     });
                          //   }
                          // }
                        }
                      });
                    
                    // ALERT BEERCLAIM QI -----------
                    await axios.get("/Api/Users/GetNotify").then(function(response) {
                      if (response.status == 200) {
                        if(response.data.notificationBody !== null){
                          alertStep.push({
                            "title" :  response.data.notificationTitle,
                            "body" : '<p style="text-align: left;">' +
                              response.data.notificationBody +
                              "</p>",
                            "icon" : "warning",
                          })
                        }
                        if(response.data.notificationBodyPMPastDue !== null){
                          alertStep.push({
                            "title" :  response.data.notificationTitlePMPastDue,
                            "body" : '<p style="text-align: left;">' +
                                  response.data.notificationBodyPMPastDue +
                                  "</p>",
                            "icon" : "warning",
                          })
                        }
                        if(response.data.notificationBodyPMAdvance !== null){
                          alertStep.push({
                            "title" :  response.data.notificationTitlePMAdvance,
                            "body" : '<p style="text-align: left;">' +
                                  response.data.notificationBodyPMAdvance +
                                  "</p>",
                            "icon" : "warning",
                          })
                        }
                        // if (response.data.notificationBody !== null) {
                        //   Swal.fire({
                        //     title: response.data.notificationTitle,
                        //     html:
                        //       '<p style="text-align: left;">' +
                        //       response.data.notificationBody +
                        //       "</p>",
                        //     icon: "warning",
                        //   }).then((result) => {
                        //     if (response.data.notificationBodyPM !== null) {
                        //       Swal.fire({
                        //         title: response.data.notificationTitlePM,
                        //         html:
                        //           '<p style="text-align: left;">' +
                        //           response.data.notificationBodyPM +
                        //           "</p>",
                        //         icon: "warning",
                        //       });
                        //     }
                        //   });
                        // }
                      }                                                                                                                                                   
                    });

                     
                      await axios.get("/Api/Users/GetBeerClaimQINotify").then(function(response) {
                        if (response.status == 200) {
                          if (response.data.isNotification) {
                            alertStep.push({
                              "title" :  response.data.notificationTitle,
                              "body" : '<p style="text-align: left;">' +
                                response.data.notificationBody +
                                "</p>",
                              "icon" : "warning",
                            })
                          }
                        }
                      });
                  


                     
                      if(this.$route.fullPath=="/" || this.$route.fullPath=="/Error/Unauthorized" || this.$route.fullPath.length <= 1 ){ 
                    //check alert after logon only 
                    await axios.get("/Api/Users/GetOverdueNotify").then(function(response) {
                      if (response.status == 200) {
                        if (response.data.isNotification) {
                          alertStep.push({
                            "title" :  response.data.notificationTitle,
                            "body" : '<p style="text-align: left;">' +
                              response.data.notificationBody +
                              "</p>",
                            "icon" : "warning",
                          })
                        }
                      }
                    });
                  }
                  if(this.$route.fullPath=="/" || this.$route.fullPath=="/Error/Unauthorized" || this.$route.fullPath.length <= 1 ){ 
                    //check alert after logon only
                    await axios.get("/Api/Users/GetBeforeOverdueNotify").then(function(response) {
                      if (response.status == 200) {
                        if (response.data.isNotification) {
                          alertStep.push({ 
                            "title" :  response.data.notificationTitle,
                            "body" : '<p style="text-align: left;">' +
                              response.data.notificationBody +
                              "</p>",
                            "icon" : "warning",
                          })
                        }
                      }
                    });
                  }

                  for (currentStep = 0; currentStep < alertStep.length;) {
                    const result = await Swal.fire({
                      title: alertStep[currentStep].title,
                      html: alertStep[currentStep].body,
                      icon : alertStep[currentStep].icon,
                      showCancelButton: currentStep > 0,
                      currentProgressStep: currentStep,
                      reverseButtons: true,
                      cancelButtonText: 'Back',
                    })

                    if (result.value || result.dismiss == 'backdrop') {
                      currentStep++
                    } else if (result.dismiss == "cancel") {
                      currentStep--
                    } else {
                      break
                    }
                  }
                  // ALERT BEERCLAIM QI -----------
                  });
              });
          });
      });

    this.startCheckTimer();
    window.addEventListener('mousemove', this.resetTimer);
    window.addEventListener('keydown', this.resetTimer);
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('storage', this.handleStorageChange);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    if (localStorage.getItem('showCheckTimeoutModal') === 'true') {
      this.showCheckTimeoutModal();
    }

    this.hideEmptyMenuSections();
  },
  updated: function () {
    // สิทธิ์/โปรไฟล์โหลดแล้ว sidebar re-render → คำนวณหัวข้อเมนูใหม่
    //   merge เข้า sit/c-20260831 (13/10/2026): 2 CR แก้ปัญหาหัวข้อเมนูว่างแยกกัน และต่างคนต่างมี updated()
    //   key ซ้ำใน object literal ตัวหลังจะทับตัวแรกเงียบ ๆ จึงรวมไว้ที่ hook เดียว เรียกครบทั้งสอง
    this.syncMenuSections();       // CR-StockCoverDays QA BUG-02 — ซ่อนหัวข้อที่ไม่มีลิงก์ปลายทางใน DOM
    this.hideEmptyMenuSections();  // CR-FormSummaryStock QA เรื่องที่ 2 — ซ่อนหัวข้อที่ไม่มีเมนูที่มองเห็นได้
  },
};
</script>

<style lang="scss">
/* FS-123 — ไอคอนเครื่องพิมพ์ของเมนู "พิมพ์เอกสารสรุปข้อมูลทรัพย์สิน" : เหลือง #FFC107 · ชื่อเมนูใช้สีเดิมของธีม
   hover ที่เมนู (ไอคอนหรือชื่อ) → #FF7300 (ส้ม) — ทุกสถานะ รวมตอนเมนูถูกเลือก/กางอยู่
   (FS-123 รอบแก้ (2) : #FFE9A6 · FS-132 19/10/2026 ผู้ใช้สั่งเปลี่ยนเป็น #FF7300)
   !important เพราะ Metronic กำหนดสีไอคอนด้วย selector ยาวหลายชั้นตามสถานะเมนู */
.kt-aside-menu .kt-menu__item.fss-menu > .kt-menu__link .kt-menu__link-icon > i {
  color: #ffc107 !important;
}

.kt-aside-menu .kt-menu__item.fss-menu > .kt-menu__link:hover .kt-menu__link-icon > i {
  color: #ff7300 !important;
}

html.swal2-shown,
.swal2-container {
  overflow-y: auto !important;
  height: auto !important;
}

.label-required::before {
  content: "";
  border-left: 2px solid #cc0000;
  margin-right: 5px;
}

.label-warning::before {
  content: "";
  border-left: 2px solid #e4af00;
  margin-right: 5px;
}

th.sorting_disabled {
  padding-right: 0 !important;
}

.my-style {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  font-size: 13px;
  margin: 0 5px 5px;
  margin-bottom: 5px;
  align-items: center;
  justify-content: center;

  &,
  &>div {
    box-sizing: border-box;
  }

  background: #ffb648;
  border: 2px solid #f3a734;

  .my-style-icon {
    flex: 0 1 auto;
    color: #ffb648;
    font-size: 32px;
    padding: 0 10px;
  }

  .my-style-close {
    flex: 0 1 auto;
    padding: 0 20px;
    font-size: 16px;
    opacity: 0.2;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .my-style-content {
    padding: 10px;
    flex: 1 0 auto;

    .my-style-title {
      letter-spacing: 1px;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
    }
  }
}

.vue-treeselect__control {
  padding-left: 5px;
  padding-right: 5px;
  display: table;
  table-layout: fixed;
  width: 100%;
  height: 41.5px;
  border: 1px solid #ebedf2;
  border-radius: 5px;
  background: #fff;
  transition-duration: 200ms;
  transition-property: border-color, box-shadow, width, height, background-color,
    opacity;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}

.vue-treeselect__multi-value-item {
  cursor: pointer;
  display: inline-table;
  background: #ebedf2;
  padding: 2px 0;
  border: 1px solid transparent;
  border-radius: 2px;
  color: #a7abc3;
  font-size: 15px;
  vertical-align: top;
}

.vue-treeselect__value-remove {
  color: #a7abc3;
  padding-left: 5px;
  border-left: 1px solid #fff;
  line-height: 0;
}

.vue-treeselect__limit-tip-text {
  cursor: default;
  display: block;
  margin: 2px 0;
  padding: 1px 0;
  color: #bdbdbd;
  font-size: 15px;
  font-weight: 600;
}

.vue-treeselect--multi .vue-treeselect__input-container {
  display: inline-block;
  font-size: 15px;
  vertical-align: top;
}

.vue-treeselect__checkbox {
  display: none;
  margin: auto;
  width: 12px;
  height: 12px;
  border-width: 1px;
  border-style: solid;
  border-radius: 2px;
  position: relative;
  transition: 200ms all cubic-bezier(0.075, 0.82, 0.165, 1);
}

.vue-treeselect__tip-text {
  display: table-cell;
  vertical-align: middle;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  font-size: 15px;
}

.Collapsible__content[data-v-545f03a3] {
  overflow: hidden;
}

.Collapsible__contentInner[data-v-545f03a3] {
  height: auto;
}

.Collapsible__trigger[data-v-545f03a3] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  background: transparent;
  border-radius: 0;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-align: inherit;
  color: inherit;
  padding: 0;
  margin: 0;
  display: block;
  width: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// App/App.vue